const TRAN_HUY_LIEU_SCHOOL_CODE = '79768507';

export const isTranHuyLieu = (user) => {
  const schoolCode = user?.schools?.[0]?.code;
  return schoolCode === TRAN_HUY_LIEU_SCHOOL_CODE;
};
